/** Roteamento por hash (#/administracao/usuarios …) — não exige configuração no servidor. */
import { useEffect, useState } from 'react';

export function useRota(): string {
  const [rota, setRota] = useState(() => window.location.hash.replace(/^#/, '') || '/');
  useEffect(() => {
    const ao = () => setRota(window.location.hash.replace(/^#/, '') || '/');
    window.addEventListener('hashchange', ao);
    return () => window.removeEventListener('hashchange', ao);
  }, []);
  return rota;
}

export function navegar(rota: string): void {
  window.location.hash = rota;
}
